import { http } from 'services';

interface IProps {
  fileName: string;
  downloadApiUrl: string;
  onDownloadProgress?: (percent: number) => void;
  endDownloadProgress?: () => void;
}

const downloadFile = ({ fileName, downloadApiUrl, onDownloadProgress, endDownloadProgress }: IProps) => {
  http.request
    .get(downloadApiUrl, {
      responseType: 'arraybuffer',
      onDownloadProgress: progressEvent => {
        let percentCompleted = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
        return onDownloadProgress && onDownloadProgress(percentCompleted);
      }
    })
    .then(({ data }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .finally(endDownloadProgress && endDownloadProgress);
};

export default downloadFile;
